import React from 'react'
/* import { makeStyles } from '@material-ui/core/styles' */
import { Container, Grid, Paper } from '@material-ui/core'
import NotificationForm from '../Components/NotificationForm'
import LastNotifications from '../Components/LastNotifications'
/* import clsx from 'clsx' */

/* const useStyle = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 300,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: '1.5rem',
  },
  pos: {
    marginBottom: 12,
  },
})) */

export default function Notifications(props) {
  /*   const classes = useStyle()
   */ return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper elevation={4} style={{ paddingBottom: 40 }}>
          <NotificationForm></NotificationForm>
          <Container maxWidth='md'>
            {/* <LastNotifications></LastNotifications> */}
          </Container>
        </Paper>
      </Grid>
    </Grid>
  )
}
